import { render, staticRenderFns } from "./RatesSettings.vue?vue&type=template&id=3a5a0b11&scoped=true&"
import script from "./RatesSettings.vue?vue&type=script&lang=ts&"
export * from "./RatesSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RatesSettings.vue?vue&type=style&index=0&id=3a5a0b11&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a0b11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VRow,VSwitch})
